import { Loader2Icon } from "lucide-react";
import type React from "react";
import { cn } from "@/lib/utils";

/**
 * Spinner is decorative by default: it bakes in no user-facing string (the repo
 * i18n rule forbids hardcoded English/Polish, and screen-reader labels count).
 * Inside `<Button loading>` the button keeps its own accessible label and
 * `aria-disabled` conveys the busy state, so the spinner is `aria-hidden`.
 * Standalone callers that need an announced status must pass a translated
 * `aria-label` (e.g. `t("common:labels.loading")`), which switches it to `role=status`.
 */
export function Spinner({
  className,
  "aria-label": ariaLabel,
  ...props
}: React.ComponentProps<typeof Loader2Icon>): React.ReactElement {
  const decorative = ariaLabel === undefined;
  return (
    <Loader2Icon
      aria-hidden={decorative || undefined}
      aria-label={ariaLabel}
      className={cn("animate-spin", className)}
      role={decorative ? undefined : "status"}
      {...props}
    />
  );
}
